import { render, staticRenderFns } from "./PlayingIcon.vue?vue&type=template&id=1c4c484b&scoped=true&"
import script from "./PlayingIcon.vue?vue&type=script&lang=js&"
export * from "./PlayingIcon.vue?vue&type=script&lang=js&"
import style0 from "./PlayingIcon.vue?vue&type=style&index=0&id=1c4c484b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4c484b",
  null
  
)

export default component.exports